var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdownField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.577.686v5.045h12.846V.578L.577.686z",
    transform: "translate(-152 -519) translate(120 504) translate(32 11) translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M10.826 3.674c.037.038.086.057.136.057.049 0 .098-.019.136-.057l.769-.769c.055-.055.071-.137.041-.21-.03-.071-.1-.118-.177-.118h-1.539c-.077 0-.148.047-.177.119-.03.072-.014.154.041.21l.77.768z",
    transform: "translate(-152 -519) translate(120 504) translate(32 11) translate(0 4)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownField);
export default __webpack_public_path__ + "static/media/dropdown-field.54471d91.svg";
export { ForwardRef as ReactComponent };